import { DocsWikiLayout } from "../components/DocsWikiLayout";

export default function Docs() {
  return <DocsWikiLayout />;
}
